import { FunctionComponent } from 'react'

import styled from 'styled-components'

import { IconProps } from '@fairhq/common/lib/components/atoms/icons/types'

const StyleDiv = styled.div<{ backgorundColor: string }>`
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background-color: ${({ backgorundColor }) => backgorundColor};
`

export const Dot: FunctionComponent<IconProps> = ({
  fill = 'currentColor',
}) => <StyleDiv backgorundColor={fill} />
